import React from 'react';
import { CalendarOutlinedIcon, DateRangeDropdown, EXTENDED_RANGE_DATE_KEYS } from '@common-fe/common-fe';

const RANGE_OPTIONS = [
  EXTENDED_RANGE_DATE_KEYS.ALL,
  EXTENDED_RANGE_DATE_KEYS.LAST_7_DAYS,
  EXTENDED_RANGE_DATE_KEYS.LAST_30_DAYS,
  EXTENDED_RANGE_DATE_KEYS.LAST_QUARTER,
  EXTENDED_RANGE_DATE_KEYS.LAST_YEAR,
];

interface Props {
  disabled?: boolean;
  rangeOptions?: string[];
  defaultTitle?: string;
  testId?: string;
  values: [Date | null, Date | null];
  onChangeValues: (values: [Date | null, Date | null]) => void;
  prefix: string;
  preRangeNode?: React.ReactNode;
}
const ReportDateRange: React.FC<Props> = ({
  prefix,
  testId = 'report-date-range',
  values,
  rangeOptions,
  defaultTitle,
  disabled,
  onChangeValues,
  preRangeNode,
}) => {
  return (
    <DateRangeDropdown
      testId={testId}
      // clearMode
      defaultTitle={defaultTitle}
      startDate={values[0]}
      endDate={values[1]}
      ellipsisMode
      disabled={disabled}
      isTwoCalendars={false}
      prefix={prefix ? `${prefix}:` : undefined}
      ranges={rangeOptions || RANGE_OPTIONS}
      preRangeNode={preRangeNode}
      icon={<CalendarOutlinedIcon color={disabled ? 'iconDisabled' : 'iconPrimary'} />}
      onChange={onChangeValues}
    />
  );
};
export default ReportDateRange;
